import store from '@state/store.js'
import getSignalRToken from '@services/signalr/getSignalRToken.js'

export default async function() {
  await getSignalRToken()
  store.commit('signalr/CLEAR_RETRY_COUNT')
}
